import React from 'react'
import { Redirect } from 'react-router-dom'
import { Footer, Header, Helmet } from 'shared/components'
import Branding from 'shared/branding'
import cognito from 'shared/cognito'
import ApplicationDataCapture from './ApplicationDataCapture'
import { APPLICATION_PATHS } from 'constants/paths'

const AdverseActionPage = () => {
  const { name, } = Branding.current

  const isPasswordless =
    localStorage.getItem('isPasswordlessFlow') === 'true' &&
    cognito.primaryRegion()

  return (
    <div className="mainBody">
      <Helmet brandName={name} pageName="Adverse Action" />
      <Header showLogInText={isPasswordless} />
      <ApplicationDataCapture
        render={({ appId, applicationType, denial }) => {
          const coolOffPeriodEndDate = denial && denial.coolOffPeriodEndDate
          return (
            <Redirect
              to={{
                pathname: APPLICATION_PATHS.ADVERSE_ACTION_THANK_YOU,
                state: { applicationId: appId, coolOffPeriodEndDate, applicationType },
              }}
            />
          )
        }}
      />
      <Footer />
    </div>
  )
}

export default AdverseActionPage
